import * as React from 'react';
import FindControlViewState from 'owa-recipient-types/lib/types/FindControlViewState';
import getFloatingPickerProps from '../utils/getFloatingPickerProps';
import tryForceResolve from '../utils/tryForceResolve';
import updateQueryString from '../actions/updateQueryString';
import { IPeopleFloatingPickerProps } from 'office-ui-fabric-react/lib/FloatingPicker';
import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import { ITheme } from '@uifabric/styling';
import { observer } from 'mobx-react';
import CommonFindControl from 'owa-readwrite-common-well/lib/components/CommonFindControl';

export interface FindPeopleControlProps {
    viewState: FindControlViewState;
    onItemSelected: (item: FindRecipientPersonaType) => void;
    focusAutomatically: boolean;
    openPickerAutomatically: boolean;
    className?: string;
    inputAriaLabel?: string;
    onInputChanged?: (value: string) => void;
    onPaste?: (value: string) => void;
    onBlur?: () => void;
    onInputKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    theme?: ITheme;
    onPickerHidden?: () => void;
    editingRecipientInputClassName?: string;
}

@observer
export default class FindPeopleControl extends React.Component<FindPeopleControlProps, {}> {
    private findControl: CommonFindControl = null;

    public focus = () => {
        this.findControl.focus();
    };

    public clearInput = () => {
        this.findControl.clearInput();
    };

    public showPicker = () => {
        if (this.findControl) {
            this.findControl.showPicker();
        }
    };

    public hidePicker = () => {
        if (this.findControl) {
            this.findControl.hidePicker();
        }
    };

    public getFloatingPicker = () => {
        if (this.findControl) {
            return this.findControl.getFloatingPicker();
        }
        return null;
    };

    private getPickerProps = (): IPeopleFloatingPickerProps => {
        return getFloatingPickerProps(
            this.getViewState,
            this.getFloatingPicker,
            true /*controlledComponent*/,
            this.props.theme,
            this.props.onPickerHidden
        );
    };

    private onOpenPickerAutomatically = () => {
        if (this.props.viewState.inForceResolve) {
            tryForceResolve(this.getViewState, this.findControl.getFloatingPicker());
        } else {
            this.showPicker();
        }
    };

    render() {
        return (
            <CommonFindControl
                ref={ref => (this.findControl = ref)}
                className={this.props.className}
                inputAriaLabel={this.props.inputAriaLabel}
                inputClassName={this.props.editingRecipientInputClassName}
                onBlur={this.props.onBlur}
                onPaste={this.props.onPaste}
                defaultVisibleQueryString={this.getViewState().queryString}
                onInputKeyDown={this.props.onInputKeyDown}
                getPickerProps={this.getPickerProps}
                onInputChanged={this.onInputChanged}
                suggestionItems={this.props.viewState.findResultSet.slice()}
                onItemSelected={this.props.onItemSelected}
                theme={this.props.theme}
                onOpenPickerAutomatically={this.onOpenPickerAutomatically}
                focusAutomatically={this.props.focusAutomatically}
                openPickerAutomatically={this.props.openPickerAutomatically}
            />
        );
    }

    private getViewState = (): FindControlViewState => {
        return this.props.viewState;
    };

    private onInputChanged = (value: string) => {
        updateQueryString(this.props.viewState, value);
        if (this.props.onInputChanged) {
            this.props.onInputChanged(value);
        }
    };
}
